// 20/10/2026 : toute confirmation `data-turbo-confirm` passait par la fenêtre du
// navigateur (« 127.0.0.1:3004 indique », boutons OK / Annuler, police du
// système). Omar, sur Ventes : « la confirmation est vraiment nulle ». Turbo
// laisse remplacer cette fenêtre : on en ouvre une de BEB, un <dialog> natif
// (Échap, focus piégé, retour du focus sur le bouton : tout est fourni).
//
// Sur l'élément qui porte la confirmation (le bouton, sinon le formulaire) :
//   data-turbo-confirm      le titre, une question courte
//   data-confirm-texte      une phrase sous le titre (facultatif)
//   data-confirm-bouton     le mot du bouton (« Confirmer » par défaut)
//   data-confirm-danger     bouton rouge, et le focus part sur « Annuler »
//
// Hors des coquilles de BEB (.admin-shell, .public-shell), les jetons de
// couleur n'existent pas : on garde la fenêtre du navigateur.
import { Turbo } from "@hotwired/turbo-rails"

let dialogue = null

function construire() {
  const d = document.createElement("dialog")
  d.className = "beb-confirm"
  d.setAttribute("aria-labelledby", "beb-confirm-titre")
  d.innerHTML = `
    <form method="dialog" class="beb-confirm-corps">
      <h2 id="beb-confirm-titre" class="beb-confirm-titre"></h2>
      <p class="beb-confirm-texte"></p>
      <div class="beb-confirm-actions">
        <button value="non" class="btn beb-confirm-annuler">Annuler</button>
        <button value="oui" class="btn btn-primary beb-confirm-ok"></button>
      </div>
    </form>`
  // Un clic sur le voile (hors de la carte) vaut « Annuler ».
  d.addEventListener("click", (e) => { if (e.target === d) fermer(d, "non") })
  d.addEventListener("cancel", (e) => { e.preventDefault(); fermer(d, "non") })
  // Les deux boutons passent aussi par fermer(), pour jouer la sortie.
  d.querySelector("form").addEventListener("submit", (e) => {
    e.preventDefault()
    fermer(d, e.submitter?.value || "non")
  })
  document.body.appendChild(d)
  return d
}

function fermer(d, valeur) {
  if (!d.open || d.dataset.fermeture) return
  d.dataset.fermeture = "1"
  d.removeAttribute("data-ouvert")
  const fin = () => { delete d.dataset.fermeture; d.close(valeur) }
  // La sortie dure --duree-rapide-02 ; sans transition (mouvement réduit,
  // onglet en arrière-plan), on ferme quand même.
  d.addEventListener("transitionend", fin, { once: true })
  setTimeout(() => { if (d.open) fin() }, 200)
}

function lire(cle, ...sources) {
  for (const s of sources) {
    if (s?.dataset && s.dataset[cle] !== undefined) return s.dataset[cle]
  }
  return undefined
}

export function confirmer(message, element, submitter) {
  const coquille = document.body.matches(".admin-shell, .public-shell")
  if (!coquille || typeof HTMLDialogElement !== "function") {
    return Promise.resolve(window.confirm(message))
  }
  if (!dialogue || !dialogue.isConnected) dialogue = construire()
  const d = dialogue
  const texte  = lire("confirmTexte", submitter, element)
  const bouton = lire("confirmBouton", submitter, element) || "Confirmer"
  const danger = lire("confirmDanger", submitter, element) !== undefined

  d.querySelector(".beb-confirm-titre").textContent = message
  const p = d.querySelector(".beb-confirm-texte")
  p.textContent = texte || ""
  p.hidden = !texte
  const ok = d.querySelector(".beb-confirm-ok")
  ok.textContent = bouton
  ok.classList.toggle("beb-confirm-danger", danger)
  d.returnValue = ""

  return new Promise((resolve) => {
    d.addEventListener("close", () => resolve(d.returnValue === "oui"), { once: true })
    d.showModal()
    ;(danger ? d.querySelector(".beb-confirm-annuler") : ok).focus()
    requestAnimationFrame(() => d.setAttribute("data-ouvert", ""))
  })
}

if (Turbo.config?.forms) {
  Turbo.config.forms.confirm = confirmer
} else {
  Turbo.setConfirmMethod(confirmer)
}
